<app-spinner *ngIf="loadingFlag"></app-spinner>
<div class="agent-request-container">

  <mat-card id="page-container">
   
    <mat-card-title >
      <h2 class="card-title">Commission Discrepancy Form</h2>
    </mat-card-title>

    <div class="mat-card-body-container">

      <form [formGroup]="agentResourceForm" novalidate  class="card-content">

      <div class="mat-card-body-top">
        <h3>
          Please complete this form to request a review of commisssion discrepancy, our team will investigate and make 
          necessary corrections. Enter an Application Number or Student Number. The form fields will be populated with information from the system.</h3> 
      </div>

      <div class="mat-card-body-center">                  
              
              <mat-form-field appearance="outline" class="half-width">
                <mat-select matNativeControl placeholder="Agent Name" required  formControlName="agentNameListCtrl">
                  <ng-container *ngFor="let agent of agentsList">
                    <mat-option  [value]="agent.Agent_EMPLID">
                      {{ agent.Agent_Name }}
                    </mat-option>
                  </ng-container>                
                  </mat-select>
                  <mat-error *ngIf="agentResourceForm.get('agentNameListCtrl').invalid">
                    {{DisplayErrorMessage(agentResourceForm.get('agentNameListCtrl'))}}
                  </mat-error>
              </mat-form-field>                          
            
              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Application Number</mat-label>
                <input *ngIf="!missingInfo" matInput placeholder="Application Number" formControlName="applicationNumberCtrl" required  maxlength="11" (blur)="onAppIDAndCode()">
                <input *ngIf="missingInfo" matInput [value]="missingInfo[0].Application_Id" formControlName="applicationNumberCtrl" (blur)="onAppIDAndCode()">  
                <mat-error *ngIf="agentResourceForm.get('applicationNumberCtrl').hasError('required')"><em class="error-hint">Required</em> </mat-error>
                <mat-error *ngIf="agentResourceForm.get('applicationNumberCtrl').hasError('pattern')"><em class="error-hint"> Invalid application number</em> </mat-error>                        
              </mat-form-field>   

              <mat-form-field appearance="outline" class="quarter-width" >
                  <mat-label>Student Number</mat-label>
                  <input *ngIf="!missingInfo" matInput placeholder="Student Number" formControlName="studentNumberCtrl"  maxlength="50" (blur)="onAppIDAndCode()">   
                  <input *ngIf="missingInfo" matInput [value]="missingInfo[0].Student_Number" formControlName="studentNumberCtrl" (blur)="onAppIDAndCode()">         
              </mat-form-field>                                                                   

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Student Last Name</mat-label>
                <input *ngIf=!missingInfo matInput value=''   maxlength="50">
                <input *ngIf=missingInfo matInput disabled [value]='missingInfo[0].Last_name'   maxlength="50">                                      
              </mat-form-field>
              
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Student First Name</mat-label>
                <input *ngIf=!missingInfo matInput value=''   maxlength="50">
                <input *ngIf=missingInfo matInput disabled [value]='missingInfo[0].First_Name'   maxlength="50">                                    
              </mat-form-field>              

              <mat-form-field appearance="outline" class="quarter-width">
                <mat-label>Campus</mat-label>
                <input *ngIf=!missingInfo matInput value=''   maxlength="50">
                <mat-select *ngIf="missingInfo" formControlName="programCampusCtrl" required (selectionChange)="updateProgramFromCampus($event)">
                  <mat-option *ngFor="let el of this.campusList" [value]="el.Campus_DESC">{{el.Campus_DESC}}</mat-option>
                </mat-select>  
              </mat-form-field> 

              <mat-form-field appearance="outline" class="quarter-width" >
                <mat-label>Program Code</mat-label>
                <input *ngIf="!missingInfo" matInput placeholder="Program Code" formControlName="programCodeCtrl"  maxlength="5">  
                <mat-select *ngIf="missingInfo" (selectionChange)="updateProgramFromCode($event)" formControlName="programCodeCtrl" required>
                  <mat-option *ngFor="let el of this.displayedCode" [value]="el.ACAD_PROG">{{el.ACAD_PROG}}</mat-option>
                </mat-select>                      
              </mat-form-field>                               

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Program Name</mat-label>
                <input *ngIf="!missingInfo" matInput placeholder="Program Name" formControlName="programNameCtrl"   maxlength="100">      
                <input *ngIf=missingInfo matInput disabled [value]='chosenProgram'   maxlength="50">  
              </mat-form-field>            

                <mat-form-field appearance="outline" class="quarter-width">
                  <mat-label>Term</mat-label>
                  <input *ngIf="!missingInfo" matInput placeholder="Term" formControlName="termCtrl"  maxlength="50">  
                  <mat-select *ngIf="missingInfo" [(ngModel)]="selectedTermOption" formControlName="termCtrl" required>
                    <mat-option *ngFor="let el of this.termsList" [value]="el.Term">{{el.Name}}</mat-option>
                  </mat-select>      
                </mat-form-field> 

                <mat-form-field appearance="outline" class="quarter-width" floatLabel="always">                
                  <span matPrefix class="cad">$ CAD </span>  
                  <input matInput  class="example-right-align"  placeholder="Tuition Amount (optional)" formControlName="tuitionAmountCtrl">    
                  <mat-error *ngIf="agentResourceForm.get('tuitionAmountCtrl').hasError('required')"><em class="error-hint">Required</em> </mat-error>
                  <mat-error *ngIf="agentResourceForm.get('tuitionAmountCtrl').hasError('pattern')"><em class="error-hint"> Invalid tuition amount</em> </mat-error>                                     
                </mat-form-field>     

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Comments</mat-label>
                <textarea matInput placeholder="Comments *" formControlName="commentsCtrl" maxlength="500" required></textarea>    
                      
              </mat-form-field>
              <div class="mat-form-field">
                <mat-label>Max 500 characters</mat-label><mat-label class="rightFlex"> {{ differenceLength | async }} / 500</mat-label>
              </div>                
                   
            <div class="mat-card-body-bottom-item">
              
              <div class="right-buttons">
                <button type="submit" mat-flat-button class="is-rounded" color="primary"
                [disabled]="agentResourceForm.invalid" [class.active]="agentResourceForm.valid" 
                (click)="onSubmit()">
                  <span>Submit</span>
                </button>
                <button mat-stroked-button class="is-rounded red" color="primary" [routerLink]="['/iap/commissions/', {queryParams:0}]">
                  <span>Cancel</span>
                </button>

              </div>
           
            </div>

        </div>

      </form>

    </div>
  
  </mat-card>

</div>
